module.exports = __webpack_public_path__ + "static/media/6-1.5717fcf4.jpg";